import React from 'react'

function FilterCheckbox({ label, checked, onChange }) {
  return (
    <label className="flex items-center gap-2 text-start text-p-2 font-semibold">
      <input
        className="checked:before:bg-gf-gradient relative inline-block size-8 cursor-pointer appearance-none rounded-sm border border-neutral-blue-600 bg-neutral-blue-700 p-2 before:absolute before:left-1/2 before:top-1/2 before:size-6 before:-translate-x-1/2 before:-translate-y-1/2 before:rounded-[2px]"
        type="checkbox"
        checked={checked}
        onChange={onChange}
      />
      {label}
    </label>
  )
}

export default React.memo(FilterCheckbox)
